import React from "react"
import { ThemeProvider } from "styled-components"

import { isGifImage } from "components/cloudinary-image"
import componentThemeExtension from "utils/componentThemeExtension"

import HeroContent from "components/hero/content"
import { Wrapper, Left, Right, ImageLink, ImageCropped, Caption, CreditSource } from "./styles"

const TextAndImage = ({ element }) => {
  const { anchor, image, heading, text, isMirrored } = element

  if (!image) {
    return null
  }

  const imageSizes = {
    1024: [671, 99999],
    768: [472, 99999],
    0: [480, 99999],
  }

  const imageAndMedia = (
    <>
      <ImageCropped
        fetchpriority="low"
        imageData={image}
        sizes={[
          {
            query: 1024,
            width: imageSizes[1024][0],
            height: imageSizes[1024][1],
            transforms: `c_pad,w_${imageSizes[1024][0]},q_auto,f_auto,fl_lossy`,
          },
          {
            query: 768,
            width: imageSizes[768][0],
            height: imageSizes[768][1],
            transforms: `c_pad,w_${imageSizes[768][0]},q_auto,f_auto,fl_lossy`,
          },
          {
            query: 0,
            width: imageSizes[0][0],
            height: imageSizes[0][1],
            transforms: `c_pad,w_${imageSizes[0][0]},q_auto,f_auto,fl_lossy`,
          },
        ]}
        alt={image.altText}
        contain
      />
      {image.caption && <Caption>{image.caption}</Caption>}
      {image.credit && (
        <CreditSource>{`${image.credit}${image.source ? ` / ${image.source}` : ""}`}</CreditSource>
      )}
    </>
  )

  return (
    <Wrapper id={`mbg-${anchor}`}>
      <Left>
        <ThemeProvider theme={componentThemeExtension("Light Background Primary")}>
          <HeroContent heading={{ text: heading }} body={text} isArticle />
        </ThemeProvider>
      </Left>
      <Right reverseOrder={isMirrored}>
        {image.path && !isGifImage(image.path) && image.linkUrl ? (
          <ImageLink href={image.linkUrl} target="_blank">
            {imageAndMedia}
          </ImageLink>
        ) : (
          imageAndMedia
        )}
      </Right>
    </Wrapper>
  )
}

export default TextAndImage
